import React, { type JSX } from 'react';

import { useQuery } from '@apollo/client/react';
import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { Navigate } from 'react-router';

import { BuyerAppointmentsDocument } from '../graphql/queries/__generated__/BuyerAppointments';
import { BuyerAppointmentCard } from './BuyerAppointmentCard';
import { ContentCard } from './ContentCard';
import { ContentWrapper } from './ContentWrapper';
import LadyAtDeskIcon from './icons/LadyAtDeskIcon';
import { Loader } from './Loader';

const BuyerAppointmentsSection: React.FC = () => {
  const { data, loading, error } = useQuery(BuyerAppointmentsDocument);

  let content: JSX.Element | null = null;

  if (error) {
    return <Navigate to="/error" />;
  }

  if (loading) {
    content = <Loader size="small" />;
  }

  if (data) {
    if (data.buyerAppointments.length === 0) {
      content = (
        <Col className="w-full items-center">
          <LadyAtDeskIcon />
          <Text as="p" className="text-body-md py-3 text-center">
            No active buyer appointments.
          </Text>
          <Text as="p" className="text-body-md text-center">
            Customers who schedule a tour for a home in your community will show up here. Please
            reach out to your Homebuilder Partner Manager if you have any questions.
          </Text>
        </Col>
      );
    } else {
      content = (
        <>
          {data.buyerAppointments.map((buyerAppointment, i) => (
            <BuyerAppointmentCard key={i} buyerAppointment={buyerAppointment} />
          ))}
        </>
      );
    }
  }

  return (
    <ContentWrapper>
      <ContentCard title="Buyer Appointments">
        <Text as="p" className="text-body-sm pb-2">
          Track your new home tour requests generated from Opendoor here.
        </Text>
        {data?.buyerAppointments && (
          <Text as="p" className="text-label-md pb-3">
            <>
              {data.buyerAppointments.length}
              {data.buyerAppointments.length === 1 ? ' result' : ' results'}
            </>
          </Text>
        )}
        {content}
      </ContentCard>
    </ContentWrapper>
  );
};

export default BuyerAppointmentsSection;
